import ModalContext from 'contexts/ModalContext'
import React, { ComponentProps, useCallback, useContext } from 'react'
import _LoyaltyPointsEarn from './_LoyaltyPointsEarn'
import LoyaltyPointsEarnBreakdownModal from './LoyaltyPointsEarnBreakdownModal'

type InheritedPriceRowLoyaltyPointsProps = Omit<ComponentProps<typeof _LoyaltyPointsEarn>, 'onInfoIconClick'>

interface Props extends InheritedPriceRowLoyaltyPointsProps {
  /**
   * @default "Earning points"
   */
  modalTitle?: string
}

function LoyaltyPointsEarnWithBreakdownModal({ modalTitle, calculationRequests, ...rest }: Props) {
  const showModal = useContext(ModalContext)
  const handleInfoClick = useCallback(() => {
    showModal(<LoyaltyPointsEarnBreakdownModal calculationRequests={calculationRequests} title={modalTitle || 'Earning points'} />)
  }, [showModal, calculationRequests, modalTitle])

  return <_LoyaltyPointsEarn {...rest} calculationRequests={calculationRequests} onInfoIconClick={handleInfoClick} />
}

export default LoyaltyPointsEarnWithBreakdownModal
